var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Helper from '@ember/component/helper';
import { all, restartableTask, timeout } from 'ember-concurrency';
import { waitForTransition } from '../../utils/transition';
export let TransitionVisibilityManager = (_class = class TransitionVisibilityManager extends Helper {
  constructor(...args) {
    super(...args);
    /**
     * Represents whether or not the `Transition` should be visible
     */
    _defineProperty(this, "value", false);
    /**
     * Tracks the last `this.show` value, so we can determine if we need to initiate a transition as part of `compute`
     * being executed
     *
     * This is because `compute` is sometimes called because an argument changed (and we want to kick off a new
     * transition) and sometimes it's called to update the produced value during an existing transition (and we *do
     * not* want to kick off a new transition)
     *
     * @type {undefined|boolean}
     */
    _defineProperty(this, "previousShowValue", undefined);
  }
  /**
   * All of the DOM nodes related to a transition
   *
   * Includes the parent element plus any children
   *
   * @type {Set<HTMLElement>}
   */
  get domNodes() {
    return this.args[0];
  }

  /**
   * The `Transition` component's `this.args.show` value
   *
   * Represents the desired visibility of the component.
   *
   * @type {boolean}
   */
  get show() {
    return this.args[1];
  }
  isInitialRender() {
    return typeof this.previousShowValue === 'undefined';
  }
  shouldTransition() {
    return this.show !== this.previousShowValue;
  }
  compute(positionalArgs) {
    this.args = positionalArgs;
    if (this.isInitialRender()) {
      this.value = this.show;
    } else if (this.shouldTransition()) {
      if (this.show) {
        this.value = true;
      } else {
        this.unmountAfterTransitionTask.perform();
      }
    }
    this.previousShowValue = this.show;
    return this.value;
  }
  *unmountAfterTransitionTask() {
    // Wait for the next tick, to ensure that the class name string has time to re-build
    yield timeout(0);

    // Wait for all Transition DOM elements to finish transitioning (parent and children)
    yield all(Array.from(this.domNodes).map(domNode => waitForTransition(domNode)));
    this.value = false;
    this.recompute();
  }
}, _applyDecoratedDescriptor(_class.prototype, "unmountAfterTransitionTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "unmountAfterTransitionTask"), _class.prototype), _class);